import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setLocale, translateSelector } from '@ackee/jerome/antd';

import { languages } from 'localization/index';

import LanguageSwitcher from '../components/LanguageSwitcher';

export default connect(
    state => {
        const { locale: activeLanguage } = translateSelector(state);
        return {
            languages,
            activeLanguage,
        };
    },
    dispatch => ({
        changeLanguage: bindActionCreators(setLocale, dispatch),
    }),
)(LanguageSwitcher);
